import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-otp-form',
  imports: [FormsModule, ReactiveFormsModule, NgOtpInputModule, NgClass],
  standalone: true,
  templateUrl: './otp-form.component.html',
  styleUrl: './otp-form.component.scss'
})
export class OtpFormComponent {
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false
  };
  formValues = output<string>();
  isLoading = input<boolean>();

  otpVerificationForm = new FormGroup({
    otpCode: new FormControl('', [Validators.required, Validators.minLength(6)])
  });

  submitOtpVerificationForm() {
    if (this.otpVerificationForm.valid) {
      let otpCode = this.otpVerificationForm.getRawValue().otpCode as string;
      this.formValues.emit(otpCode);
    }
  }

  onOtpChange(otp: any): void {
    this.otpVerificationForm.controls['otpCode']?.patchValue(otp);
  }
}
